
  import Vue from 'vue'

  import PriceInfoDialog from '@/components/entities/price/PriceInfoDialog.vue';
  import PriceEditDialog from '@/components/entities/price/PriceEditDialog.vue';
  import PriceDeleteDialog from '@/components/entities/price/PriceDeleteDialog.vue';
  import { objectsToCSV, filterItem } from '@/utils/Util';

  export default Vue.extend({
    name: 'PricesTable',

    components: {
      PriceInfoDialog,
      PriceEditDialog,
      PriceDeleteDialog
    },
    props: ['prices', 'loading'],
    data: (vm: any): any => ({
      tableLoadingText: vm.loadingText,
      search: "",
      showUUIDs: false,
      numberOfEntities: 0,
      selectedHeaders: [
          { text: vm.$t('attribute.type'), value: 'type', index: 1 },
          { text: vm.$t('attribute.subtype'), value: 'subtype', index: 2 },
          { text: vm.$t('attribute.basePrice'), value: 'basePrice', index: 3 },
          { text: vm.$t('attribute.perUsePrice'), value: 'perUsePrice', index: 4 },
          { text: vm.$t('attribute.discountRange'), value: 'discountRange', index: 5 },
          { text: vm.$t('attribute.createdAt'), value: 'createdAt', index: 7 },
      ]
    }),
    async created() {
      if(this.prices.length === 0) {
        this.tableLoadingText = this.$t('price.noData') as string;
      }

      const columns = this.$root.$store.getters.selectedColumns('price');
      if(columns) {
        this.selectedHeaders = columns;
      }
    },
    watch: {
      selectedHeaders() {
        this.$store.commit("setSelectedColumns", { type: 'price', columns: this.selectedHeaders });
      } 
    },
    methods: {
      filterItem,
      onExport() {
          let filteredItems = this.prices;
          if(this.$refs.dataTable.$children[0].filteredItems) {
            filteredItems = this.$refs.dataTable.$children[0].filteredItems;
          }

          // Data structure
          const data = filteredItems.map((prop: any, index: number) => Object({
            uuid: prop.id,
            type: prop.type,
            subtype: prop.subtype,
            basePrice: prop.basePrice,
            perUsePrice: prop.perUsePrice,
            discountRange: prop.discountRange,
            tenantId: prop.tenantId,
            createdAt: prop.createdAt,
            updatedAt: prop.updatedAt,
          }));

          const filename = 'bascloud_prices.csv';
          const csvContent = objectsToCSV(data);
          var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

          if ((navigator as any).msSaveBlob) { // IE 10+
              (navigator as any).msSaveBlob(blob, filename);
          } else {
              var link = document.createElement("a");
              if (link.download !== undefined) { // feature detection
                  // Browsers that support HTML5 download attribute
                  var url = URL.createObjectURL(blob);
                  link.setAttribute("href", url);
                  link.setAttribute("download", filename);
                  link.style.visibility = 'hidden';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
              }
          }
      },
      onReload() {
        this.$emit("reload");
      },
      onItemUpdate(item: any) {
        this.$emit("update", item);
      },
      onItemDelete(item: any) {
        this.$emit("delete", item);
      },
      onPaginationAndFilter(pagination: any) {
        this.numberOfEntities = pagination.itemsLength;
      },
      onTableRowClick(row: any) {
        const button: any = this.$refs["priceInfoButton_" + row.uuid];
        // $el needed for native elements
        button.$el.click();
      },
      getTenantByUUID(uuid: string) {
        return this.$root.$store.state.session.tenants.find((element: any) => element.uuid === uuid);
      },
      toCurrencyString(price: number) {
          return price ? price.toLocaleString(undefined, { style: 'currency', currency: 'EUR' }) : null;
      },
    },
    computed: { 
      headers() {
        return [
          { text: this.$t('attribute.uuid'), value: 'uuid', index: 0 },
          { text: this.$t('attribute.type'), value: 'type', index: 1 },
          { text: this.$t('attribute.subtype'), value: 'subtype', index: 2 },
          { text: this.$t('attribute.basePrice'), value: 'basePrice', index: 3 },
          { text: this.$t('attribute.perUsePrice'), value: 'perUsePrice', index: 4 },
          { text: this.$t('attribute.discountRange'), value: 'discountRange', index: 5 },
          { text: this.$t('attribute.updatedAt'), value: 'updatedAt', index: 6 },
          { text: this.$t('attribute.createdAt'), value: 'createdAt', index: 7 },
        ];
      },  
      tableFooterProps(): any {
        return {
          'items-per-page-options': [5, 10, 15, 30, -1],
          'items-per-page-text': this.$t('itemsPerPageText'),
        };
      },
      loadingText(): any {
        return this.$t('price.loadingData');
      },
      computedTableHeader(): any {

        return [...this.selectedHeaders,
          { text: this.$t('attribute.actions'), value: 'actions', sortable: false, filterable: false, index: 100 },
        ].sort((a: any, b: any) => a.index-b.index);
      },
      canUpdate(): any {
        if (this.$root.$store.state.session.permissions.resources && 'prices' in this.$root.$store.state.session.permissions.resources) {
          return this.$root.$store.state.session.permissions.resources['prices'].includes('PATCH');
        } else {
          return false;
        }
      },
      canDelete(): any {
        if (this.$root.$store.state.session.permissions.resources && 'prices' in this.$root.$store.state.session.permissions.resources) {
          return this.$root.$store.state.session.permissions.resources['prices'].includes('DELETE');
        } else {
          return false;
        }
      },
    },
  })
